const emptyAuthState = {
  user: {},
  accreditations: [],
  currentInvitation: {},
  isLoading: false,
  publicApiToken: null,
  twoFactorChallenge: null,
  twoFactorStatus: null,
  twoFactorSetup: null
}

export default emptyAuthState
